import numberFormats from "../../konfi_mobile/src/data/numberFormats";
import {ChromoLogoColor} from "./selectableObjects";


export type Farbgruppe = {
    palette:string;
    gruppenNummer:number;
    aufloesen_in_konfi_mobile:boolean;
}


export type PalettenEintragFromDB = {
    NameImWeb : string;
    RGBHex : string;
    isAdditionalColor : boolean;
}


export interface PalettenCluster {
    [key: string]: PalettenEintragFromDBWithFarbgruppenEinteilung[]
}

export interface PalettenClusterSorted {
    [key: string]: PalettenEintragFromDBWithFarbgruppenEinteilung[][]
}


export type PalettenEintragFromDBWithFarbgruppenEinteilung = {
    NameImWeb : string,
    RGBHex : string,
    farbGruppeUndPosition:{farbgruppe:number, positionInGruppe:number};
};

export const NOCOLOR_PALETTENEINTRAG = {
    NameImWeb : "none",
    RGBHex : "none",
    farbGruppeUndPosition:{farbgruppe:0, positionInGruppe:0}
} as PalettenEintragFromDBWithFarbgruppenEinteilung;

export type CurrentproductPossibleDesignEntry = {
    ColorCodeAbhaengigkeiten: unknown[],
    ColorCodesWithOutline: string,
    Design: string,
    KonfiDiscarded: "0"|"1",
    Pfad: string,
    Realdesign: string,
    ausgeblendeteColorCodes: string[]
    baseColors: string[]
}

export type EntwurfListenEintragFromBackend = {
    Name,
    SaveID,
    Produkt,
    DreiDModell,
    IsInWarenkorb,
    UploadedByOwayo,
    Datum,
    ProduktLokalisiert,
    Zeit,
    FeatureStr,
    anzAngelegteExemplare,
    previewImageDirectory
};

export type ArtikelFarbVariante = {
    farbe:string;
    NameImWeb:string;
    colorcode:string;
    palette:string;
    pantoneNameInPalette:string;
    RGBHex:string;
}

export type FehlendeRohlingGroesse = {Farbname:string, Groesse:string}

export type Produktresponse = {
    imKonfiKoennenPatternsVerwendetWerden: boolean;
    Urlname,
    webproduktNormalized:string,
    MindestBestellung,
    Cut,
    MaximalBestellung,
    VorbelegungPreisanzeige,
    Produkt,
    Schnitt,
    Ordertype,
    auwiSport,
    Name,
    DefaultMaterial,
    Basemodel,
    Designlist,
    designListeForDesignOverview,
    model,
    BasisDesign,
    Sizes:SizeEntry[],
    FehlendeRohlinge:FehlendeRohlingGroesse[],
    partMaterials,
    drehungInDesignauswahl,
    maxNeigung,
    maxDrehung,
    Designs,
    Warnungen,
    MengenBezeichner,
    VorgegebenerArtikel,
    Farbvarianten,
    geschlecht,
    colorcodeAliases,
    colorCodes:ColorCodeFromDB[],
    ColorCodeFarbVorbelegungen,
    DesigncheckDisabled,
    TackleTwillMoeglich,
    namesOfDroppableParts:string[],
    bwVeredelungsFeaturedObjects,
    farbBeziehungenZwischenColorCodes:ColorCodeFarbKombiBeziehung[],
    designvorschaupfad:string
    hatReadyDesigns:boolean,
    websportUnterDemDasProduktGehostetIst:string,
    websportUnterDemDasProduktGehostetIstUebersetzt:string,
    ItemID:number,
    ProduktGruppe:string
}

export type ColorcodeFarbkombi = {
    palette:string;
    NameImWeb:string;
    folgePalette:string;
    folgenameImWeb:string;
}

export type ColorCodeFarbKombiBeziehung = {
    colorCode:string;
    folgeColorCode:string;
    farbkombis:ColorcodeFarbkombi[];
}


export type ColorCodeFromDB  = {
    colorCode,
    NurSchwarzWeiss,
    IsLinkedColorCodeImWeb,
    PalettenCluster,
    ColorCodeNr,
    Farbname,
    GroupID,
    InKonfi,
    IsHideable,
    colorRGB,
    palette,
    farbname,
    ImKonfiKoennenPatternsVerwendetWerden,
    farbAbhaengigkeitsArt:ColorCodeAbhaengigkeitsArten,
    colorCodeToDisplay
}

export type EntwurfColorData = {
    bezeichnung,
    colorRGB,
    nameImWeb,
    palette,
    hatPattern
}

export class ColorCodeFromDBInfusedWithEntwurfColorData {
    public colorCode;
    public NurSchwarzWeiss;
    public IsLinkedColorCodeImWeb;
    public PalettenCluster;
    public ColorCodeNr;
    public Farbname;
    public GroupID;
    public InKonfi;
    public IsHideable;
    public colorRGB;
    public palette;
    public farbname;
    public ImKonfiKoennenPatternsVerwendetWerden;
    public farbAbhaengigkeitsArt:ColorCodeAbhaengigkeitsArten;
    public hatPattern;

    public constructor(data:ColorCodeFromDB) {
        this.colorCode = data.colorCode;
        this.NurSchwarzWeiss = data.NurSchwarzWeiss;
        this.IsLinkedColorCodeImWeb = data.IsLinkedColorCodeImWeb;
        this.PalettenCluster = data.PalettenCluster;
        this.ColorCodeNr = data.ColorCodeNr;
        this.Farbname = data.Farbname;
        this.GroupID = data.GroupID;
        this.InKonfi = data.InKonfi;
        this.IsHideable = data.IsHideable;
        this.colorRGB = data.colorRGB;
        this.palette = data.palette;
        this.farbname = data.farbname;
        this.ImKonfiKoennenPatternsVerwendetWerden = data.ImKonfiKoennenPatternsVerwendetWerden;
        this.farbAbhaengigkeitsArt = data.farbAbhaengigkeitsArt;
    }
}

export type EntwurfFromDB =  {
    username,
    derived_sport,
    derived_sportInt,
    design,
    derived_designliste,
    saveID,
    model,
    textobjects:TextObjectFromBackend[],
    logos:LogoObjectFromBackend[],
    colors:EntwurfColorData[],
    cut,
    ordertype,
    realsport,
    designlist,
    produkt,
    features,
    schnitt,
    einzelexemplare,
    sportWebInt,
    produktWebInt,
    uploadedByOwayo,
    basedOnDeprecatedProduct,
    internationalizedProduktErsetztDurch,
    produktErsetztDurchAuwiProdukt:string
    farbvariante,
    isInWarenkorb,
    vorgaengerID,
    vorgaengerName,
    designanfrage,
    name,
    visible,
    patterns,
    wasOrdered,
    patternAnker,
    rdyDesignID,
    herstellerlogosEntfernt,
}

export type MotivDataFromDB =  {
    logoObjects,
    textObjects
}

export type SizeEntry = {name,size};

export enum ColorCodeAbhaengigkeitsArten
{
    NONE= "<nix>",
    BLACK_WHITE_AS_CONTRAST= "Schwarz-Weiß im Kontrast",
    SAME_AS_OTHER_COLORCODE= "Wie B, wenn auf A; Sonst wie A",
    CLOSEST_TO_OTHER_COLORCODES_WEIGHTED_BY_PERCENTAGES= "Nahste Farbe nach Hauptfarben",
    SAME_AS_OTHER_COLORCODE_DEFINED_BY_HAND= "Händische editierte Abhängigkeit",
    HAS_COLORKOMBINATION_ACCORDING_TO_COLORCODES_REGELN= "Über Ordertype_Colorcodes_Regeln",
    VERSTECKBAR= "Versteckbar",
}

export type GroessenTabelleZeile ={
    description:string,
    kategorie:string,
    massEinheit:string,
    zellen: { value:string, columnSpan:number }[]
}

export type GroessenTabelle = {
    titel: string,
    zeilen: GroessenTabelleZeile[],
    spaltenZahl: number,
    sport: string,
    sex: string,
    icon,
    hatBrustOderHueftUmfangZeilen: boolean,
    defaultMassEinheit: string,
    alternativeMassEinheit: string
}

type preisentry = {
    grundpreisString:string
    grundpreisVereinsstaffelrabatt:string
    rabattAngewendet:boolean
    rabattierterPreisString:string
}

export type ProduktUebersichtLoaderSQLResultWithAuwiNameAndDetails = {
    name;
    Kategorie;
    imageURL;
    imageWidth;
    imageHeight;
    preise:preisentry[];
    featurePreise;
    featuresInGrundpreisContentIDs;
    Mindestbestellung;
    Mengenbezeichner;
    productShortDetailList;
    bedruckbar;
    druckNichtImPreisEnthalten;
    derzeitNichtLieferbar;
    AuwiProdukt;
    Product;
    oberkategorie;
    Anzeigesport;
    isArtikel;
    isVeredelterArtikel;
    productColors;
    ecoLogos;
    DVSchnitt;
    KonfiDiscarded;
    detailStrings:string[],
    auwiProductInt:string
}



export enum LinksToWebsite {
    angebotsService = "angebotsService",
    agbs = "agbs",
    musterservice = "musterservice",
    faq = "faq",
    lieferzeit = "lieferzeit",
    howToOrder = "howToOrder",
    product = "product",
    privacyterms = "privacyterms",
}

export type PreisPreviewResponseClass = {
    preis:number|"PREIS_ANFRAGE";
    originalPreis:number;
    symbol:string;
    isEUStaat:boolean;
    isStandardPriceList:boolean;
    inklusiveMwSt:boolean;
    waehrungsKuerzel:string
}


export type LogoPoolEntry = {
    filename;
    id;
    isEinfaerbbar;
    farbpalette;
    addedDate;
    filenameOriginal;
    uploadedByOwayo;
    breiteOriginal;
    derived_UserDataPath;
    hoeheOriginal;
    type;
    isAILogo;
    logoURL;
    thumbnailURL;
    objectstorage_key_prefix;
    original_extension;
    bucket_suffix
}


export type FileUploadResponseObject = LogoPoolEntry & {
    success:boolean;
    login:string;
}

export type ShopLogoUploadResponse =
{
    status:string;
    ShopLogoURL:string;
    error:string;
}

export enum LoginResponseCodes {
    OK,
    WRONG_CREDENTIALS,
    EMPTY_USERNAME,
    USERNAME_IS_EMAIL_AND_NOT_EXAXTLY_ONE_MATCH,
    NETWORK_ERROR
}

export type LoginResponse = {
    status:string,
    login:string,
    error:LoginResponseCodes,
    rabattCode:string,
    ansprechpartner:string,
    email:string,
    telefon:string,
    lieferland:string,
    aiLogoCredits:string,
    aiLogoCreditsUsed:string,
}


export type KI_LogoGeneration_Result = {
    finished:boolean,
    error:boolean,
    errorstring:string,
    progress:string,
    imageBase64:string,
}

export type KILogoCredits = {
    totalCredits:number,
    creditsUsed:number
}

export type ExtrapartInfo = { hasTackleTwill:boolean, berechnungsFeature:string|null }

export type SelectableObjectFromBackend = {
    rotation;
    zIndex;
    isPinned;
    floating;
    keepSeparate;
    allowDrag;
    allowDelete;
    allowResize;
    isVorbelegung;
    name;
    part;
    ursprungsMotivID;
    relSize:{x:number, y:number};
    point:{x:number, y:number};

} & ExtrapartInfo



export type TextObjectFromBackend = SelectableObjectFromBackend & {
    colorQuellpalette;
    fix;
    font;
    hasOutline;
    outlineColor;
    outlineColorQuellPalette;
    outlineWidth;
    value;
    id;
}

export type LogoObjectFromBackend = SelectableObjectFromBackend & {
    pathToLogo;
    chromoLogoId;
    stockLogoID;
    repeat;
    logoId;
    clampToColor;
    wasserzeichen;
    wasserzeichenInvertImage;
    wasserzeichenIntensity;
    allowColorChange;
    /** @var ChromoLogoColor[]  */
    colors:ChromoLogoColor[];
    isEinfaerbbar;
    dpi;
}


export type ReadydesignEntry = {
    Name: string;
    Readydesigncode : string;
    Designname : string;
    DesignnameSport : string;
    SaveID : string;
    breitePreview : string;
    hoehePreview : string;
    breite : string;
    hoehe : string;
    urlPrefix : string;
    urlPrefixPreviewResponsive : string;
    urlPrefixProduktseite : string;
    urlPrefixPreview : string;
    imageURL : string;
}
